/**
 * Copyright © 2018-present Emu Analytics
 */

import { IPipelineComponent } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';
import { Client } from './client';
import { PipelineMetricEndpoints } from './pipeline-metric.endpoint';

export class PipelineComponentEndpoints extends BaseEndpoints<IPipelineComponent> {
  constructor(client: Client, private pipelineId: string) {
    super(client, `pipelines/${pipelineId}/components`);
  }

  metrics(componentId: string) {
    return new PipelineMetricEndpoints(this.client, this.pipelineId, componentId);
  }
}
